export default __webpack_public_path__ + "static/media/sticker-8.86ca0c6e.png";